import React, {
  useCallback,
  useMemo,
} from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { Button } from '@termly/react-components'

import UINames from 'constants/ui-names'

import { useDisplayManager } from 'components/DisplayManager'

import Locale from './locale'

const FOCUS_ID = 'preferences-button'


export default function PreferencesButton({ btnStyle, className }) {
  const { pushActiveUI } = useDisplayManager()

  const handleClick = useCallback(() => {
    pushActiveUI(UINames.PREFERENCES)
  }, [pushActiveUI])

  const style = useMemo(() => ({
    ...btnStyle,
    background: 'transparent',
    color: btnStyle.preferencesBtnColor,
    borderColor: btnStyle.preferencesBtnColor,
  }), [btnStyle])

  const buttonClassName = classnames(className, 't-preference-button')

  return (
    <Button
      aria-haspopup="dialog"
      className={ buttonClassName }
      color="primary"
      data-focus-id={ FOCUS_ID }
      handleClick={ handleClick }
      style={ style }
      type="outline"
    >
      <FormattedMessage
        { ...Locale.preferences }
      />
    </Button>
  )
}

PreferencesButton.propTypes = {
  btnStyle: PropTypes.shape({
    backgrond: PropTypes.string,
    borderColor: PropTypes.string,
    color: PropTypes.string,
    fontFamily: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.string,
    preferencesBtnColor: PropTypes.string,
  }),
  className: PropTypes.string,
}
